import React from "react";
import styles from "./Logo.module.scss";
// Uncomment to reverse to used old logo
// import { ReactComponent as BtcxStandardLogo } from "../../../resources/images/btcx-standard-logo.svg";
// import { ReactComponent as BtcxStandardLogo } from "../../../resources/images/btcx-standard-logo-white-new.svg";
import { ReactComponent as BtcxStandardLogoPrint } from "../../../resources/images/btcx-print-logo.svg";

const PrintLogo = ({ className }) => (
  <BtcxStandardLogoPrint height={28} width={65} className={`${className}  btcx-logo`} />
);

export default PrintLogo;
